import { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";

const DetalleVehiculos = ({ modelo, token }) => {
  const [srcMod, setSrcMod] = useState();
  const [to, setTo] = useState("");
  const [cotizarUrl, setCotizarUrl] = useState("");
  const [testDriverUrl, setTestDriveUrl] = useState("");
  const [exoneradosUrl, setExoneradosUrl] = useState("");
  const [vehiculo, setVehiculo] = useState("");
  const [version, setVersion] = useState("");
  const [data, setdata] = useState([]);
  const [versionDefault, setversionDefault] = useState("");

  const handleChangeVersion = (e) => {
    const item = data.find(
      (element) => String(element.VER_CODIGO) === e.target.value
    );
    setTo(item.VER_URL_COTIZADOR);
    setCotizarUrl(`${item.VER_URL_COTIZADOR}?tk=${token}`);
    setExoneradosUrl(`/exonerados/staria?tk=${token}`);
    setTestDriveUrl(`/test-drive/${item.VER_URL_LANDING}?tk=xh1afe26ut`)
    setVehiculo(item.VER_MOTOR);
    setVersion(item.VER_TRANSMISION);
    setversionDefault(e.target.value);
  };

  useEffect(() => {
    let token_var = sessionStorage.getItem("tk");
    if (token === null || token === "") {
      setCotizarUrl(
        `${modelo.MOD_LISTA_VERSION[0].VER_URL_COTIZADOR}?tk=${token_var}`
      );
      setExoneradosUrl(
        `/exonerados/staria?tk=${token_var}`
      );
      setTestDriveUrl(
        `/test-drive${modelo.MOD_LISTA_VERSION[0].VER_URL_LANDING}?tk=xh1afe26ut`
      );
    } else {
      setCotizarUrl(
        `${modelo.MOD_LISTA_VERSION[0].VER_URL_COTIZADOR}?tk=${token}`
      );
      setTestDriveUrl(
        `/test-drive${modelo.MOD_LISTA_VERSION[0].VER_URL_LANDING}?tk=xh1afe26ut`
      );
    }

    const getListVersion = () => {
      if (modelo.MOD_LISTA_VERSION.length > 0) {
        setTo(modelo.MOD_LISTA_VERSION[0].VER_URL_LANDING);
        setSrcMod(modelo.MOD_FOTO_PRINCIPAL);
        setVehiculo(modelo.MOD_LISTA_VERSION[0].VER_MOTOR);
        setVersion(modelo.MOD_LISTA_VERSION[0].VER_TRANSMISION);
        setversionDefault(String(modelo.MOD_LISTA_VERSION[0].VER_CODIGO));
        setdata(modelo.MOD_LISTA_VERSION);
      }
    };
    getListVersion();
  }, [modelo, token]);

  return (
    <Fragment>
      <Container className="p-md-4 bg-sand">
        <Row>
          <Col lg={12}>
            <div className="detalle-modelo">
              <Row>
                <Col lg={5}>
                  <Row class="d-flex justify-content-center">
                    <Col md={10} lg={12}>
                      <Image
                        src={srcMod}
                        fluid
                        alt="Hyundai versión"
                        id="imgVersion"
                        className="d-none d-lg-block"
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={7}>
                  <Row>
                    <Col lg={12}>
                      <Form.Group>
                        <Form.Label className="detalle-label mt-movil-select-version">
                          Seleccione una versión
                        </Form.Label>
                        <Form.Control
                          id="version"
                          name="version"
                          as="select"
                          className="catalogo-version custom-select"
                          onChange={handleChangeVersion}
                          value={versionDefault}
                        >
                          <option value="" disabled>
                            -- SELECCIONE UNA OPCION --
                          </option>
                          {data.map((row) => (
                            <option key={row.VER_CODIGO} value={row.VER_CODIGO}>
                              {row.VER_NOMBRE}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <Form.Label className="detalle-label">
                        Visión general
                      </Form.Label>
                      <Table bordered hover className="tabla-modelo">
                        <tbody>
                          <tr>
                            <td className="bg-tabla-sand">Motor</td>
                            <td className="bg-tabla-white">{vehiculo}</td>
                          </tr>
                          <tr>
                            <td className="bg-tabla-sand">Transmisión</td>
                            <td className="bg-tabla-white">{version}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <Row className="testd justify-content-center flex-nowrap d-none d-md-flex" style={{ gap: '0.5rem' }}>
                    {/*
                    {modelo.MOD_ACTIVO_EXONERADO === 1 && (
                      <Col
                        md={3}
                        lg={3}
                        className="mt-0 mt-md-0 pl-md-2 mt-lg-4 d-flex justify-content-center"
                      >
                        <Button
                          as={Link}
                          to={exoneradosUrl}
                          variant="primary"
                          id="botonOpciones"
                          type="button"
                          className="btn-landing px-2 py-1 w-100"
                          style={{ fontSize: '0.95rem' }}
                        >
                          Exonerados
                        </Button>
                      </Col>
                    )}
                    */}
                    
                    <Col
                      md={3}
                      lg={3}
                      className="mt-0 mt-md-0 pl-md-2 mt-lg-4 d-flex justify-content-center"
                    >
                      <Button
                        as={Link}
                        to={to}
                        variant="primary"
                        id="botonOpciones"
                        className="text-decoration-none btn-landing px-2 py-1 w-100"
                        style={{ fontSize: '0.95rem' }}
                      >
                        Más Información
                      </Button>
                    </Col>
                    <Col
                      md={3}
                      lg={3}
                      className="mt-md-2 pl-md-2 mt-lg-4 d-flex justify-content-center"
                    >
                      <Button
                        as={Link}
                        to={cotizarUrl}
                        variant="primary"
                        id="botonOpciones"
                        type="submit"
                        className="btn-landing px-2 py-1 w-100"
                        style={{ fontSize: '0.95rem' }}
                      >
                        Cotizar
                      </Button>
                    </Col>
                    <Col
                      md={3}
                      lg={3}
                      className="mt-md-2 mt-lg-4 d-flex justify-content-center"
                    >
                      <Button
                        as={Link}
                        to={testDriverUrl}
                        variant="primary"
                        id="botonOpciones"
                        type="submit"
                        className="btn-landing px-2 py-1 w-100"
                        style={{ fontSize: '0.95rem' }}
                      >
                        Test Drive
                      </Button>
                    </Col>
                  </Row>
                  <div className="d-flex flex-column align-items-center d-md-none mt-1">
                    {/*
                    {modelo.MOD_ACTIVO_EXONERADO === 1 && (
                      <Button
                        as={Link}
                        to={exoneradosUrl}
                        variant="primary"
                        id="botonOpciones"
                        type="button"
                        className="btn-landing w-100 mb-2"
                        style={{ fontSize: '1rem' }}
                      >
                        Exonerados
                      </Button>
                    )}
                    */}
                    <Button
                      as={Link}
                      to={to}
                      variant="primary"
                      id="botonOpciones"
                      className="text-decoration-none btn-landing w-100 mb-2"
                      style={{ fontSize: '1rem' }}
                    >
                      Más Información
                    </Button>
                    <Button
                      as={Link}
                      to={cotizarUrl}
                      variant="primary"
                      id="botonOpciones"
                      type="submit"
                      className="btn-landing w-100 mb-2"
                      style={{ fontSize: '1rem' }}
                    >
                      Cotizar
                    </Button>
                    <Button
                      as={Link}
                      to={testDriverUrl}
                      variant="primary"
                      id="botonOpciones"
                      type="submit"
                      className="btn-landing w-100"
                      style={{ fontSize: '1rem' }}
                    >
                      Test Drive
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default DetalleVehiculos;